import { render, staticRenderFns } from "./LafiaStudio.vue?vue&type=template&id=0c9489d7&scoped=true"
import script from "./LafiaStudio.vue?vue&type=script&lang=js"
export * from "./LafiaStudio.vue?vue&type=script&lang=js"
import style0 from "./LafiaStudio.vue?vue&type=style&index=0&id=0c9489d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9489d7",
  null
  
)

export default component.exports